<ng-container *ngFor="let message of news">
  <app-news-item [message]="message"></app-news-item>
</ng-container>
